import React from "react"
import { SVG } from "./style"

export type TSVGIcon = {
  path: string
  width?: number
  height?: number
  color?: string
  hoverColor?: string
  viewBox?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

function SVGIcon(props: TSVGIcon) {
  const { path, width = 36, height = 36, viewBox, color, hoverColor, className } = props

  return (
    <SVG width={width} height={height} color={color} viewBox={viewBox} hoverColor={hoverColor} className={className}>
      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#${path}`} href={`#${path}`} />
    </SVG>
  )
}

export default SVGIcon
